exports.default = "<div class=\"documentationcenter_tab\"> <ee-documentcentreadvancedsearchbar></ee-documentcentreadvancedsearchbar> </div>";